$('#rewards-container').on('cocoon:after-insert', function(e) {
   $('[data-toggle="tooltip"]').tooltip();
});
